(function () {
  'use strict';

  angular
    .module('cosmicRadiationReport', [
      'ui.router'
    ]);
}());
